import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { ActivatedRoute, Params } from '@angular/router';
import { RedirectStateService } from './redirect-state.service';


@Injectable({
  providedIn: 'root'
})
export class RouteHistoryService {

  param: Params;
  previous = new Subject<string>();
  
  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private redirectStateService: RedirectStateService
  ) { 
    this.route.queryParams.subscribe(param => {
      this.param = param;
      this.persistOrigin(param);
    });
  }

  referrerOrigin(): string {
    const cached = this.redirectStateService.get();
    return this.getRedirectOrigin(this.param?.redirect)
      || this.param?.origin
      || this.param?.ref
      || cached.origin
      || this.authService.referrerOrigin();
  }

  private persistOrigin(param: Params) {
    const cached = this.redirectStateService.get();
    const originCandidate = this.getRedirectOrigin(param?.redirect)
      || param?.origin
      || param?.ref
      || cached.origin
      || this.authService.referrerOrigin();

    if (originCandidate) {
      this.redirectStateService.set({ origin: originCandidate });
    }
  }

  private getRedirectOrigin(redirect: unknown): string {
    if (typeof redirect !== 'string' || !redirect.trim()) {
      return '';
    }

    try {
      const url = new URL(redirect);
      return url.protocol === 'http:' || url.protocol === 'https:' ? url.origin : '';
    } catch {
      return '';
    }
  }
}
